/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : apiTypes.ts
 *
 * Project Title : RDR7000
 *
 * Description   : API Redux Middleware actions
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Oct 08, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Oct 08, 2020
 * Description   : Add code to define actions for middleware making API calls
 *
 *
 ******************************************************************************/

import { createAction } from '@reduxjs/toolkit';
import { AxiosRequestConfig } from 'axios';

export interface IAPIPayload {
  url: string;
  params?: Object;
  data?: Object;
  responseType?: string;
  onStart?: string;
  onSuccess?: string;
  onError?: string;
  showGlobalError?: boolean;
  method?: AxiosRequestConfig['method'];
}

export const apiCallBegan = createAction('api/callBegan', function prepare(payload: IAPIPayload) {
  return {
    payload,
  };
});
export const apiCallSuccess = createAction('api/callSuccess');
export const apiCallFailed = createAction('api/callFailed');
